const copyShareUrl = (url, showSnackbar) => {
    // console.log('url = ', url);
    // console.log('showSnackbar = ', showSnackbar);
    navigator.permissions
        .query({ name: "clipboard-write" })
        .then((result) => {
            // Check if we can use the async clipboard API.
            if (result.state === "granted" || result.state === "prompt") {
                navigator.clipboard.writeText(url).then(
                    () => {
                        /* clipboard successfully set */
                        // console.log('copy success');
                        showSnackbar(
                            "Public Report URL Copied to Clipboard",
                            "success"
                        );
                    },
                    () => {
                        /* clipboard write failed */
                        // console.log('copy failed');
                        showSnackbar(
                            "Error Copying Public Report URL to Clipboard",
                            "error"
                        );
                    }
                );
            }
        })
        .catch(() => {
            // We're in an older broweser that doesn't support the async clipboard API, so we need to use the older method for copying content to the clipboard.
            const el = document.createElement("textarea");
            el.value = url;
            el.setAttribute("readonly", "");
            el.style.position = "absolute";
            el.style.left = "-9999px";
            document.body.appendChild(el);
            el.select();
            try {
                document.execCommand("copy");
                showSnackbar(
                    "Public Report URL Copied to Clipboard",
                    "success"
                );
            } catch (err) {
                showSnackbar(
                    "Error Copying Public Report URL to Clipboard",
                    "error"
                );
            }
            document.body.removeChild(el);
        });
};

export default copyShareUrl;
